<template>
  <div id="accueil">

    <!-- SLIDER -->
    <section id="slider" class="fullheight parallax parallax-4" style="background-image:url('/static/assets/img/night.jpg');">
      <div class="overlay dark-3"></div>

      <div class="container mt-20">

        <div class="title-container slider-featured-text text-center">

          <h1 class="text-white wow fadeInDown" data-wow-delay="0.4s">
            NodLight
          </h1>

          <h2 class="fw-300 text-white wow fadeInUp mt-20 hidden-sm-down text-uppercase" data-wow-delay="0.8s">
            Eclairage public connecté
          </h2>

        </div>

        <div class="row mt-100">

          <div class="col-xl-4">

            <div class="card card-discover wow fadeInUp ">
              <div class="card-body" v-scroll-to="{ el: '#offre'}">
                Découvrir notre solution
              </div>
            </div>

          </div>

          <div class="col-xl-4">

            <div class="card card-connexion wow fadeInUp ">

              <div class="card-body" @click="is_connexion_open = true">

                <div class="card-link-to-connect" v-if="!is_connexion_open" title="Se connecter à CityLi">
                  Se connecter à <b class="small-letter-spacing">CityLi</b>
                </div>

                <transition name="fade">
                  <div class="sky-form" v-if="is_connexion_open">

                    <div class="row">

                      <div class="col-12 mb-10">
                        <b class="fs-10 text-uppercase">Saisir votre login</b>
                        <label class="input">
                          <input type="text" maxlength="50" v-model="connexion.login" v-on:keyup.enter="setConnexion()" autofocus="true">
                          <b class="tooltip tooltip-bottom-right">Veuillez saisir votre login</b>
                        </label>
                      </div>

                      <div class="col-12 mb-10">
                        <b class="fs-10 text-uppercase">Saisir votre mot de passe</b>
                        <label class="input">
                          <input type="password" maxlength="50"  v-model="connexion.pass" v-on:keyup.enter="setConnexion()"/>
                          <b class="tooltip tooltip-bottom-right">Veuillez saisir votre mot de passe</b>
                        </label>
                      </div>

                    </div>

                    <div class="mt-20">
                      <a href="javascript:void(0)" @click="setConnexion()" class="btn btn-lg btn-reveal btn-primary w-100p">
                        <i class="fa fa-unlock"></i>
                        <span class="block">JE ME CONNECTE</span>
                      </a>
                    </div>

                    <transition name="fade">

                      <div class="mt-25" v-if="connexion.is_error">
                        <div class="alert alert-danger mb-0">
                          Le login ou le mot de passe est incorrect
                        </div>
                      </div>

                      <div class="mt-25" v-if="connexion.is_error_non_actif">
                        <div class="alert alert-danger mb-0">
                          Le compte est inactif, veuillez contacter votre administrateur
                        </div>
                      </div>

                    </transition>

                    <!-- <div class="mt-15">
                    Pas de compte ? Veuillez contacter votre administrateur local.
                  </div> -->

                </div>

              </transition>

            </div>
          </div>

        </div>

        <div class="col-xl-4">

          <div class="card card-fonction wow fadeInUp">
            <div class="card-body" v-scroll-to="{ el: '#contact'}">
              Démonstration
            </div>
          </div>

        </div>

      </div>

    </div>

  </section>
  <!-- /SLIDER -->

  <section class="alternate wow fadeIn" id="offre">

    <div class="container">

      <header class="text-center mb-60">
        <h2>Une offre à bas coût pour les petites et moyennes infrastructures.</h2>
        <hr/>
      </header>

      <div class="row">

        <div class="col-md-4">

          <div class="box-icon box-icon-center box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/shield.png" width="64px"/>
              <h2>
                <b>Sécurité</b>
              </h2>
            </div>
            <p class="text-muted">Améliore le confort urbain et la sécurité des usagers.</p>
          </div>

        </div>

        <div class="col-md-4">

          <div class="box-icon box-icon-center  box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/file.png" width="64px"/>
              <h2>
                <b>Réduction des coûts</b>
              </h2>
            </div>
            <p class="text-muted">Réduit les interventions humaines et favorise l'économie d'énergie.</p>
          </div>

        </div>

        <div class="col-md-4">

          <div class="box-icon box-icon-center box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/shuffle.png" width="64px"/>
              <h2>
                <b>Adaptation</b>
              </h2>
            </div>
            <p class="text-muted">S'adapte en temps réel aux événements de la ville.</p>
          </div>

        </div>

        <div class="col-md-4">

          <div class="box-icon box-icon-center box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/settings.png" width="64px"/>
              <h2>
                <b>Gestion</b>
              </h2>
            </div>
            <p class="text-muted">Gestion de l'éclairage facile en quelques clics et sans connaissances techniques.</p>
          </div>

        </div>

        <div class="col-md-4">

          <div class="box-icon box-icon-center box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/eye.png" width="64px"/>
              <h2>
                <b>Prévention</b>
              </h2>
            </div>
            <p class="text-muted">Prévient le vandalisme et le repiquage sauvage d'électricité.</p>
          </div>

        </div>

        <div class="col-md-4">

          <div class="box-icon box-icon-center box-icon-round box-icon-transparent box-icon-large">
            <div class="box-icon-title active">
              <img src="/static/assets/img/checked.png" width="64px"/>
              <h2>
                <b>Facilité</b>
              </h2>
            </div>
            <p class="text-muted">Installation facile dans les armoires électriques.</p>
          </div>

        </div>

      </div>

    </div>
  </section>


  <section class="callout-dark heading-title heading-arrow-bottom" style="z-index:100;" id="fonctionnement">
    <div class="container">
      <div class="text-center">
        <h3>FONCTIONNEMENT</h3>
      </div>
    </div>
  </section>

  <section id="about" class="alternate wow fadeIn">

    <div class="container">

      <header class="text-center mb-60">
        <h2>Un éclairage autonome et intelligent</h2>
        <p class="lead">Le système est synchronisé sur l'horloge universelle, il prend en compte les changements d'heures été / hiver, <br/> s'adapte en fonction des heures de lever et coucher du soleil, exécute des programmes prédéfinis et bien plus encore.
          <hr />
        </header>

        <div class="row">

          <div class="col-sm-6 wow fadeInLeft">
            <figure class="box-shadow-2">
              <img class="img-fluid" src="/static/assets/img/nodlight_eclairage_public_connecte-eclairage_connecte.jpg" alt="Eclairage connecté" title="Eclairage connecté" />
            </figure>
          </div>

          <div class="col-sm-6">

            <div class="wow fadeInRight">
              <p class="mb-10">
                <strong class="c-green">Comment ça fonctionne ?</strong>
              </p>

              <p class="dropcap text-justify">
                Le système de gestion d'éclairage <b class="small-letter-spacing">CityLi</b> centralise l'éclairage de votre commune.
                Notre solution se compose d'un logiciel de gestion en ligne communiquant à distance avec un ou plusieurs automates <b class="small-letter-spacing">SL200</b>.
              </p>
            </div>

            <hr />

            <div class="wow fadeInRight">

              <p class="mb-10">
                <strong class="c-green">Un système flexible qui permet</strong>
              </p>

              <ul class="text-justify">
                <li>de rendre autonome votre éclairage.</li>
                <li>de réduire votre facture d'énergie en ajustant finement les durées d'allumage.</li>
                <li>de surveiller les installations et d'être prévenus au moindre incident.</li>
                <li>d'être reprogrammé à distance à chaque instant depuis votre smartphone ou votre ordinateur.</li>
                <li>de définir des plages horaires de fonctionnement de l'éclairage.</li>
                <li>de matérialiser les zones d'éclairage sur une carte Google Maps.</li>
                <li>d'inclure des jours exceptionnels sans limitation.</li>
                <li>de synchroniser l'éclairage sur le lever et le coucher du soleil.</li>
              </ul>

            </div>

          </div>

          <div class="col-12">
            <p class="mb-10">

              <div class="row">

                <div class="col-xl-6 wow fadeInLeft">

                  <p class="mb-10">
                    <strong class="c-green">
                      Une prise en main immédiate
                    </strong>
                  </p>

                  <ul class="text-justify">
                    <li>L'interface est dynamique et s'illumine en fonction des zones d'éclairage en temps réel. </li>
                    <li>Visualisez rapidement l'état de l'ensemble de votre parc d'éclairage. </li>
                    <li>Le tableau de bord, intuitif et ergonomique vous facilite la navigation et la compréhension des différents écrans. </li>
                    <li>L'ensemble des paramètres est accessible en quelques clics facilitant ainsi la programmation même pour les plus novices. </li>
                    <li>Le mode de configuration avancée vous offre des outils de paramètrages supplémentaires. </li>
                    <li>Re-paramétrez à distance les plages horaires et critères de contrôle selon vos souhaits et sans limitation. </li>
                  </ul>

                </div>

                <div class="col-xl-6 wow fadeInRight">
                  <figure class="box-shadow-2">
                    <img class="img-fluid" src="/static/assets/img/nodlight_eclairage_public_connecte-cityli_zones.png" alt="Centre de contrôle CityLi" title="Centre de contrôle CityLi"/>
                  </figure>
                </div>

              </div>

            </p>
          </div>

        </div>


      </div>
    </section>

    <section class="p-md parallax parallax-2 pt-100 pb-100 heading-title" style="background-image: url(/static/assets/img/back.jpg);">
      <div class="overlay dark-5"></div>

      <div class="container wow fadeIn">

        <div class="text-center mb-100">
          <h2 class="text-uppercase">Notre offre <span>comprend</span></h2>
        </div>

        <div class="row">

          <div class="col-xl-6 text-center">
            <a target="_blank" href="/static/assets/img/nodlight_eclairage_public_connecte-module_SL200.jpg" class="lightbox" title="Module SL200">
              <div class="thumbnail image-hover-zoom p-0">
                <img class="" src="/static/assets/img/nodlight_eclairage_public_connecte-module_SL200.jpg" alt="Module SL200" title="Module SL200" height="280px"/>
              </div>
              <h4>Gestion centralisée Nodlight avec les modules rails din.</h4>
            </a>
          </div>

          <div class="col-xl-6 text-center">
            <a target="_blank" href="/static/assets/img/nodlight_eclairage_public_connecte-cityli.png" class="lightbox" title="Centre de contrôle CityLi">
              <div class="thumbnail image-hover-zoom p-0" style="height: 280px;">
                <img class="" src="/static/assets/img/nodlight_eclairage_public_connecte-cityli.png" alt="Centre de contrôle CityLi" title="Centre de contrôle CityLi" height="280px"/>
              </div>
              <h4>Le centre de contrôle <b class="small-letter-spacing">CityLi</b>.</h4>
            </a>
          </div>

        </div>

      </div>

    </section>

    <section class="callout-dark heading-title heading-arrow-bottom" style="z-index:100;" id="contact">
      <div class="container text-center">
        <h3>
          Contactez nous
        </h3>
        <span class="font-lato fs-24 hidden-xs-down">pour une offre personnalisée ou une démonstration de notre solution</span>

      </div>
    </section>

    <div style="background: url(/static/assets/img/gce_nous_contacter.png) center center">
      <section class="alternate" style="background-color: rgba(255, 255, 255, 0.7) !important">

        <div class="container">

          <div class="contact-over-box float-right">

            <div class="row">
              <div class="col-md-12 text-center mb-0">

                <img src="/static/assets/img/telephone.png" width="64px" class="pt-10 pb-10"/>

                <div class="mt-15 mb-0">
                  <b class="fs-20">
                    <a href="tel:+33285526520">02.85.52.65.20</a>
                  </b>
                </div>

              </div>
            </div>

            <hr/>

            <fieldset>

              <div class="row">
                <div class="col-md-12 text-center mb-0">

                  <img src="/static/assets/img/edit.png" width="64px" class="pt-10 pb-10"/>

                </div>
              </div>

              <div class="row sky-form">

                <div class="col-md-12 mb-20">
                  <label for="contact-name"><b>NOM *</b></label>
                  <div class="input">
                    <i class="ico-append fa fa-user-o"></i>
                    <input type="text" v-model="contact.name" id="contact-name"/>
                  </div>
                </div>

                <div class="col-md-12 mb-20">
                  <label for="contact-email"><b>ADRESSE EMAIL *</b></label>
                  <div class="input">
                    <i class="ico-append fa fa-at"></i>
                    <input type="email" v-model="contact.email" id="contact-email"/>
                  </div>
                </div>

                <div class="col-md-12 mb-20">
                  <label for="contact-subject"><b>SUJET *</b></label>
                  <div class="input">
                    <i class="ico-append fa fa-envelope-o"></i>
                    <input type="text" v-model="contact.subject" id="contact-subject"/>
                  </div>
                </div>

                <div class="col-md-12 mb-20">
                  <label for="contact-message"><b>VOTRE MESSAGE *</b></label>
                  <div class="textarea">
                    <textarea v-model="contact.message" id="contact-message"></textarea>
                  </div>
                </div>

              </div>

            </fieldset>

            <div class="row">
              <div class="col-md-12 text-right mb-0">

                <button type="button" class="btn btn-lg btn-reveal btn-primary w-100p" @click="sendMessage()">
                  <i class="fa fa-check"></i>
                  ENVOYER
                </button>

            </div>
          </div>

        </div>

      </div>

    </section>
  </div>

  <section class="callout-dark heading-title heading-arrow-bottom" style="z-index:100;">
    <div class="container">
      <div class="text-center">
        <h3>Qui sommes nous ?</h3>
      </div>
    </div>
  </section>


  <section id="who" class="alternate wow fadeIn">
    <div class="container">

      <div class="row">

        <div class="col-12">
          <h2 class="fs-25">NodLight est une marque de la société <strong><a href="https://www.gce-electronics.com" title="GCE Electronics">GCE Electronics</a></strong>.</h2>

          <p class="dropcap lead">
            Notre société fabrique des automates industriels et divers produits connectés pour la domotique.
            Opérant dans ce secteur depuis 2009, <strong>GCE Electronics</strong> dispose d'une forte expertise sur la conception et la fabrication de produits électroniques.
            Gage de fiabilité, les automates <strong class="small-letter-spacing">SL200</strong> sont fabriqués en France dans notre unité de production à Nantes.
            Chaque produit fait l'objet d'un contrôle rigoureux afin de garantir la meilleure qualité.
          </p>

        </div>

        <div class="col-md-6">

          <div class="thumbnail">
            <img class="img-fluid" src="/static/assets/img/gce_electronics_nodlight_locaux.jpg" alt="Nos locaux" title="Nos locaux">

          </div>

        </div>

        <div class="col-md-6">

          <img src="/static/assets/img/gce_logo.png" alt="GCE Electronics" width="100%" class="wow bounceInRight"/>

          <p>
            <span class="block">SARL au captital de 100 000 €</span>
            <span class="block">531 819 688 R.C.S Nantes</span>
            <span class="block">TVA  FR69531819688</span>
          </p>

          <p>
            <span class="block"><strong>GCE Electronics </strong></span>
            <span class="block">9 rue Jean Mermoz</span>
            <span class="block">44980 SAINTE LUCE SUR LOIRE</span>
            <span class="block"><strong>Tél:</strong> 08.11.03.48.13</span>
            <span class="block"><strong>Fax:</strong> 09.72.28.19.04</span>
          </p>

        </div>

        <div class="col-md-3">

          <div class="thumbnail">
            <img class="img-fluid" src="/static/assets/img/gce_electronics_atelier_1.jpg" alt="Une fabrication de qualitée" title="Une fabrication de qualitée">

          </div>

        </div>

        <div class="col-md-3">

          <div class="thumbnail">
            <img class="img-fluid" src="/static/assets/img/gce_electronics_atelier_2.jpg" alt="Des outils de qualités" title="Des outils de qualités">

          </div>

        </div>

        <div class="col-md-3">

          <div class="thumbnail">
            <img class="img-fluid" src="/static/assets/img/gce_electronics_equipe_1.jpg" alt="Un savoir faire" title="Un savoir faire">

          </div>

        </div>

        <div class="col-md-3">

          <div class="thumbnail">
            <img class="img-fluid" src="/static/assets/img/gce_electronics_equipe_2.jpg" alt="Une équipe à votre écoute" title="Une équipe à votre écoute">

          </div>

        </div>

      </div>

    </div>
  </section>

  <section class="callout-dark heading-title heading-arrow-bottom" style="z-index:100;">
    <div class="container">
      <div class="text-center">
        <h3>QUELQUES CHIFFRES</h3>
      </div>
    </div>
  </section>

  <section id="about" class="alternate wow fadeIn">
    <div class="container">

      <header class="text-center mb-60">
        <h2>Éclairage public</h2>
        <p class="lead">Les chiffres clés</p>
        <hr/>
      </header>

      <div class="row wow fadeInDown">

        <div class="col-12">

          <div class="d-flex justify-content-center">

            <div class="premium-thumbnail-circle">
              <a href="javascript:void(0)" class="c-default">

                <div class="spinner"></div>

                <div class="info">
                  <div class="info-back">
                    <h3>Consommation totale éclairage 56 TWh</h3>
                    <p>
                      Soit 12 % de la consommation d'électricité française.
                    </p>
                  </div>
                </div>

              </a>
            </div>
          </div>

          <div class="divider divider-color divider-center">
            <i class="fa fa-chevron-down"></i>
          </div>

        </div>

      </div>

      <div class="row wow fadeIn">

        <div class="col-md-4">
          <div class="d-flex justify-content-center">
            <div class="premium-thumbnail-circle">
              <a href="javascript:void(0)" class="c-default">

                <div class="spinner"></div>

                <div class="info">
                  <div class="info-back">
                    <h3>Bâtiments tertiaires <br/>publics et privés</h3>
                    <p>
                      37 TWh.
                    </p>
                  </div>
                </div>

              </a>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="text-center pt-100">
            <div>Taux de renouvellement en intérieur comme en extérieur : <strong>3 % par an</strong>.</div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="d-flex justify-content-center">
            <div class="premium-thumbnail-circle">
              <a href="javascript:void(0)" class="c-default">

                <div class="spinner"></div>

                <div class="info">
                  <div class="info-back">
                    <h3>Collectivités locales</h3>
                    <p>
                      23 % de la consommation d'éclairage. <br/>
                    </p>
                  </div>
                </div>

              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-50">

        <div class="col-md-4">
          <div class="d-flex justify-content-center">
            <div>
              Durée d'éclairement des bureaux par an : entre <strong>2 500</strong> et <strong>3 000</strong> heures,
              <strong>alors même que le taux de présence au poste de travail est inférieur à 70 % !</strong>
            </div>
          </div>
        </div>

        <div class="col-md-4">

        </div>

        <div class="col-md-4">
          <div class="d-flex justify-content-center">
            <div class="row text-center">

              <div class="col-6 b-dotted-right fs-18 text-nowrap">
                Éclairage intérieur<br/><strong>7 TWh</strong><br/>
              </div>

              <div class="col-6 fs-18 text-nowrap">
                Éclairage extérieur<br/><strong>5,6 TWh</strong><br/>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="row wow fadeInUp">

        <div class="col-md-8">

          <div class="divider divider-color divider-center">
            <i class="fa fa-chevron-down"></i>
          </div>

          <div class="">
            <ul class="portfolio-detail-list m-0 fs-16">
              <li><strong>80 %</strong> des installations sont non conformes</li>
              <li><strong>4 000 000 de tonnes de C0²</strong> rejetées pour rien chaque année</li>
              <li><strong>5,1 milliards d'euros</strong> dépensés chaque année pour maintenir des installations non conformes</li>
            </ul>
          </div>
        </div>

        <div class="col-md-4">

          <div class="divider divider-color divider-center">
            <i class="fa fa-chevron-down"></i>
          </div>

          <div class="">
            <ul class="portfolio-detail-list m-0 fs-16">
              <li><strong>16 %</strong> des consommations d'énergie (électricité + gaz + fioul)</li>
              <li><strong>41 %</strong> des consommations d'électricité</li>
              <li><strong>17 %</strong> des dépenses</li>
            </ul>
          </div>
        </div>

      </div>

    </div>
  </section>

  <div class="d-none">
    <div class="" id="email-send">
      <div class="row" v-if="contact.is_ok">
        <div class="col-12 text-center">
          <img src="/static/assets/img/message.png" width="64px"/>
        </div>
        <div class="col-12 text-center pt-12">
          Votre message à bien été envoyé !
          Vous receverez sous peu une réponse.
        </div>
      </div>
      <div v-else>
        <ul class="list-unstyled list-icons">
          <li v-for="error in contact.messages_error">
            <i class="fa fa-remove text-danger"></i>
            {{error}}
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>
</template>

<script>

import Alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

require('vue-style-loader!@/assets/css/app/accueil.css');

var func = require('@/assets/js/fonctions.js');

export default {

  data () {
    return {
      connexion: {
        login: undefined,
        pass: undefined,
        is_error: false,
        is_error_non_actif: false,
      },
      contact: {
        subject: "",
        message: "",
        name: "",
        email: "",
        is_ok: true,
        message_error: ""
      },
      is_connexion_open: false,
      open_contact: false,
    }
  },

  components: {
    VueRecaptcha
  },

  created () {

    Alertify.minimalDialog || Alertify.dialog('emailSend',function(){
      return {
        main:function(content){
          this.setContent(content);
        },
        hooks: {
          onclose: function() {

          }
        }
      };
    });
  },

  mounted  () {

    new WOW().init();

    func.slider_full();

    func.lightbox();

  },

  watch: {


  },

  methods : {

    /*
    * Envoi un email
    */
    sendMessage: function () {

      var params = new URLSearchParams();
      params.append('subject', this.contact.subject);
      params.append('message', this.contact.message);
      params.append('name', this.contact.name);
      params.append('email', this.contact.email);

      axios.post('/email-send.php', params).then((response) => {

        if (!response.data) {

          this.contact = {
            subject: "",
            message: "",
            name: "",
            email: "",
            is_ok: true,
            message_error: ""
          }

        } else {
          this.contact.is_ok = false;
          this.contact.messages_error = response.data;
        }

        Alertify.emailSend(document.getElementById("email-send")).setting('title', "Demande de contact");

      });

    },

    /*
    * Connexion utilisateur
    */
    setConnexion: function() {

      this.connexion.is_error = false;
      this.connexion.is_error_non_actif = false;

      if (!this.connexion.login || !this.connexion.pass) {
        this.connexion.is_error = true;
        return;
      }

      axios.post(func.url_backend + '/api/nodlight/connexion', {login: this.connexion.login, pass: this.connexion.pass}).then((response) => {

        // KO ?
        if (!response.data.ok){

          if (response.data.message == func.code_error.NON_ACTIF) {
            this.connexion.is_error_non_actif = true;
          } else {
            this.connexion.is_error = true;
          }

          return;
        }

        // Mise en session
        this.$parent.$emit('updateUser', response.data.obj);

      }).catch( (error) => {
        console.log(error);
        this.connexion.is_error = true;
      });

    }


  }

}

</script>



// WEBPACK FOOTER //
// src/components/Accueil.vue